import { useParams } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import CostView from "../views/CostView/CostView";

export default function Cost() {
	const { id } = useParams();

	const hasRight = useHasRight();

	if (!hasRight("costs.view")) {
		return <Unauthorized />;
	}

	return <CostView id={id} />;
}
